import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { PriceList } from '../../tasks/task/units/models/pricelist';
import { Inventory } from 'src/app/shared/models/inventory';
import { map, Observable, startWith, Subject, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-price-list-auto-complete',
    templateUrl: `./price-list-auto-complete.component.html`,
    styleUrl: './price-list-auto-complete.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceListAutoCompleteComponent implements OnInit, OnChanges, OnDestroy {
    @Input() @Output() selectedListAttachment: PriceList | Inventory;
    @Input() componentListSelected: boolean;
    @Input() priceLists: PriceList[];
    @Input() inventories: Inventory[];
    @Input() disabled: boolean;
    @Input() inventoryProductLicense: boolean;
    @Output() selectedListAttachmentChange: Subject<PriceList | Inventory> = new Subject<PriceList | Inventory>();
    @Output() closed: Subject<void> = new Subject<void>();

    public priceListControl: FormControl = new FormControl();
    public filteredPriceLists: Observable<PriceList[]>;
    public filteredInventories: Observable<Inventory[]>;
    
    private subscriptions: Subscription = new Subscription();

    constructor(public readonly cdRef: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.filteredPriceLists = this.priceListControl.valueChanges.pipe(
            startWith(''),
            map(value => {
              return value ? this._filter(value, this.priceLists) : this.priceLists.slice();
            }),
        );
      
        this.filteredInventories = this.priceListControl.valueChanges.pipe(
            startWith(''),
            map(value => {
              return value ? this._filter(value, this.inventories) : this.inventories.slice();
            }),
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.disabled) {
            this.priceListControl.disable();
        }
        else {
            this.priceListControl.enable();
        }
        if (changes.selectedListAttachment) {
            this.priceListControl.setValue(this.selectedListAttachment);
        }
        this.cdRef.markForCheck();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.selectedListAttachmentChange.complete();
        this.closed.complete();
    }

    public displayFn(priceList: PriceList | Inventory): string {
        if (priceList) {
            return priceList.Name;
        }
        return '';
    }

    private _filter(value: any, array: any[]): any[] {
        const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    
        return array.filter(option => option.Name.toLowerCase().includes(filterValue));
      }

    public optionSelected(event: any): void {
        this.selectedListAttachment = event?.option?.value;
        this.selectedListAttachmentChange.next(this.selectedListAttachment);
    }

    public onClosed(): void {
        this.priceListControl.setValue(this.selectedListAttachment);
        this.closed.next();
    }
}
